/**
 * Nazwa zasobu pulpitu = ścieżka kontrolera w API.
 *
 * Osobna stała, bo pulpit nie jest zasobem react-admina i nie ma go
 * w `App.tsx` — przy przemianowaniu tras (`/pulpit` → `/dashboard`)
 * literał w wywołaniu `getOne` przetrwał i ekran zaczął dostawać 404.
 * Zgodności pilnuje `resource.test.ts`.
 */
export const DASHBOARD_RESOURCE = 'dashboard';
